import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import api from '../../utils/functions/api';
import ExecutiveProjectReport, { SEVERITY_META, openProjectInErp } from './ExecutiveProjectReport';

const API = `${process.env.REACT_APP_API_URL}/ai-followup`;

// งานติดตามรายวัน — โครงการที่ต้องดูวันนี้ เรียงตามความเร่งด่วน (ส่งต่อผู้บริหาร > ประเด็นรุนแรง > คำถามเกินกำหนด > คำถามค้าง)
function DailyWorkspace() {
  const [data, setData] = useState(null);
  const [reportId, setReportId] = useState(null);

  useEffect(() => {
    api.get(`${API}/workspace`).then((res) => setData(res.data)).catch(() => setData(null));
  }, []);

  if (!data) return <Typography color="text.secondary">กำลังโหลด...</Typography>;

  return (
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1.5 }}>{data.headline}</Typography>
      <Stack spacing={1}>
        {data.rows.map((r) => {
          const sev = SEVERITY_META[r.top_severity];
          return (
            <Paper key={r.project_id} variant="outlined" sx={{ p: 1.5, borderLeft: `5px solid ${sev ? sev.color : '#9ca3af'}` }}>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>{r.label}</Typography>
                  <Stack direction="row" spacing={0.5} sx={{ my: 0.5 }} flexWrap="wrap">
                    {r.escalated > 0 && <Chip size="small" label={`ส่งต่อผู้บริหาร ${r.escalated}`} sx={{ bgcolor: '#7f1d1d', color: '#fff' }} />}
                    {r.overdue > 0 && <Chip size="small" label={`คำถามเกินกำหนด ${r.overdue}`} sx={{ bgcolor: '#fee2e2', color: '#991b1b' }} />}
                    {r.open_questions > 0 && <Chip size="small" label={`คำถามค้าง ${r.open_questions}`} />}
                    {r.pending_review > 0 && <Chip size="small" label={`รอหัวหน้าตรวจ ${r.pending_review}`} sx={{ bgcolor: '#fef3c7', color: '#92400e' }} />}
                  </Stack>
                  {r.issues.map((i) => (
                    <Typography key={i.title} variant="body2" color="text.secondary">{`• ${i.title}`}</Typography>
                  ))}
                  {r.summary && <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>{r.summary}</Typography>}
                </Box>
                <Stack direction="row" spacing={0.5} sx={{ flexShrink: 0 }}>
                  <Button size="small" variant="outlined" onClick={() => setReportId(r.project_id)}>รายงาน</Button>
                  <Button size="small" color="inherit" onClick={() => openProjectInErp(r.project_id)}>เปิดโครงการ</Button>
                </Stack>
              </Stack>
            </Paper>
          );
        })}
      </Stack>
      <ExecutiveProjectReport projectId={reportId} open={!!reportId} onClose={() => setReportId(null)} />
    </Box>
  );
}

export default DailyWorkspace;
